import { render, staticRenderFns } from "./TerraPatientIntegration.vue?vue&type=template&id=d315eff4&scoped=true"
import script from "./TerraPatientIntegration.vue?vue&type=script&lang=js"
export * from "./TerraPatientIntegration.vue?vue&type=script&lang=js"
import style0 from "./TerraPatientIntegration.vue?vue&type=style&index=0&id=d315eff4&prod&scoped=true&lang=css"
import style1 from "./TerraPatientIntegration.vue?vue&type=style&index=1&id=d315eff4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d315eff4",
  null
  
)

export default component.exports